<template>
	<div class="op2 text-left" :style="{ '--op2-top': stickyTop + 'px' }">
		<!-- Rendelés fejléc (op2-header: a dátumválasztó lenyílója kilóghat és a kosár fölé kerül) -->
		<div class="card op2-card op2-header mb-3">
			<div class="card-body py-3">
				<div class="row align-items-center">
					<div class="col-12 col-lg-5 mb-2 mb-lg-0">
						<div class="op2-customer-name">{{ rend_sel_customer.nev }}</div>
						<div class="text-muted small">
							<i class="fa fa-map-marker mr-1"></i>
							{{ rend_sel_customer.szalvaros }}, {{ rend_sel_customer.szalcim }}
							<span class="mx-1">·</span>
							<i class="fa fa-phone mr-1"></i>{{ tel || '–' }}
						</div>
						<div class="mt-1">
							<span class="badge badge-light op2-badge">Régió {{ rend_sel_customer.regio }}</span>
							<span class="badge badge-light op2-badge">Ciklus {{ rend_sel_customer.datum_limit }} nap</span>
							<span class="badge badge-light op2-badge">{{ rend_sel_customer.szolgnev || 'Nincs számla kiállító' }}</span>
							<span class="badge badge-light op2-badge">
								Ballon kint:
								<span v-if="ballon === 'error'">hiba</span>
								<span v-else-if="ballon === null">…</span>
								<span v-else>{{ ballon }}</span>
							</span>
							<span v-if="rend_sel_customer.lift_nincs == 1" class="badge badge-danger op2-badge">
								<i class="fa fa-exclamation-triangle mr-1"></i>Nincs lift
							</span>
						</div>
					</div>
					<div class="col-6 col-lg-2 small">
						<div class="text-muted">Rendelésszám</div>
						<div class="font-weight-bold">{{ rendszam }}</div>
					</div>
					<div class="col-6 col-lg-2 small">
						<div class="text-muted">Rögzítő</div>
						<div class="font-weight-bold">{{ user.nev }}</div>
					</div>
					<div class="col-12 col-lg-3 mt-2 mt-lg-0">
						<label class="text-muted small mb-1">Kért kiszállítás</label>
						<div class="d-flex align-items-center">
							<date-picker
								v-model="rend_datum"
								:config="date_options"
								@dp-change="refreshdate"
								class="form-control text-center"
							></date-picker>
							<span class="ml-2 text-capitalize small text-nowrap">{{ rend_datum | day }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<!-- Termékválasztó -->
			<div class="col-12 col-lg-9">
				<!-- Utolsó rendelés -->
				<div class="card op2-card mb-3" v-if="lastorder.length > 0">
					<div class="card-header op2-card-header d-flex align-items-center flex-wrap">
						<span class="font-weight-bold mr-2">Utolsó rendelés</span>
						<span class="text-muted small">
							kiszállítva {{ lastorder[0].kidatum | toDate }} ({{ lastorder[0].kidatum | day }})
						</span>
						<button class="btn btn-sm btn-outline-primary ml-auto" @click.prevent="addLastOrder">
							<i class="fa fa-history mr-1"></i>Teljes rendelés a kosárba
						</button>
					</div>
					<ul class="list-group list-group-flush">
						<li
							class="list-group-item d-flex align-items-center op2-last-item"
							v-for="(item, index) in lastorder"
							:key="`last-${index}`"
						>
							<div class="flex-grow-1">
								<div>{{ item.nev }}</div>
								<div class="text-muted small" v-if="item.rendmegj">
									<i class="fa fa-comment mr-1"></i>{{ item.rendmegj }}
								</div>
							</div>
							<div class="text-nowrap mx-3">{{ item.db }} db × {{ item.ar | huf }} Ft</div>
							<button class="btn btn-sm btn-light" @click.prevent="addLastItem(item)" title="Kosárba">
								<i class="fa fa-cart-plus"></i>
							</button>
						</li>
					</ul>
				</div>

				<!-- Termékek -->
				<div class="card op2-card mb-3">
					<div class="card-header op2-card-header">
						<div class="row align-items-center">
							<div class="col-12 col-md-4 col-xl-3 mb-2 mb-md-0">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text bg-white"><i class="fa fa-search"></i></span>
									</div>
									<input
										ref="search"
										type="text"
										class="form-control"
										placeholder="Termék keresése…"
										v-model="search"
									>
								</div>
							</div>
							<div class="col-12 col-md-8 col-xl-9">
								<div class="op2-tabs">
									<button
										v-for="tab in tabs"
										:key="tab.value"
										class="btn btn-sm"
										:class="activeTab === tab.value ? 'btn-primary' : 'btn-light'"
										@click.prevent="activeTab = tab.value"
									>
										{{ tab.text }}
										<span class="badge badge-pill ml-1" :class="activeTab === tab.value ? 'badge-light' : 'badge-secondary'">
											{{ tabCount(tab.value) }}
										</span>
									</button>
								</div>
							</div>
						</div>
					</div>

					<div class="card-body" :class="isGrouped ? 'op2-groups' : 'p-0'">
						<div class="text-center text-muted p-4" v-if="loading">
							<i class="fa fa-spinner fa-spin mr-1"></i>Termékek betöltése…
						</div>
						<div class="text-center text-muted p-4" v-else-if="filteredProducts.length === 0">
							Nincs a keresésnek megfelelő termék.
						</div>

						<div
							v-for="group in productGroups"
							:key="`g-${group.key}`"
							:class="{ 'op2-group': group.title }"
							:style="{ '--op2-accent': group.color }"
						>
						<div class="op2-group-header" v-if="group.title" @click="toggleGroup(group.key)">
							<span class="op2-group-icon"><i class="fa" :class="group.icon"></i></span>
							<span class="op2-group-name">{{ group.title }}</span>
							<span class="op2-group-count">{{ group.items.length }} termék</span>
							<span class="op2-group-incart" v-if="groupInCart(group) > 0">
								<i class="fa fa-shopping-cart mr-1"></i>{{ groupInCart(group) }} db a kosárban
							</span>
							<i class="fa ml-auto op2-group-chevron" :class="collapsed[group.key] ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
						</div>
						<template v-if="!collapsed[group.key]">
						<div
							v-for="p in group.items"
							:key="p.tszam"
							class="op2-product"
							:class="{ 'op2-product-incart': cartQty(p.tszam) > 0 }"
						>
							<div class="op2-product-main">
								<div class="op2-product-name">
									{{ p.nev }}
									<span v-if="cartQty(p.tszam) > 0" class="badge badge-success ml-1">
										{{ cartQty(p.tszam) }} a kosárban
									</span>
									<span v-if="isLimited(p)" class="badge badge-warning ml-1" title="Ennél a számlakiállítónál nem rögzíthető">
										<i class="fa fa-ban mr-1"></i>Számlakiállító korlát
									</span>
								</div>
								<div class="text-muted small">
									Listaár: {{ p.ar | huf }} Ft
									<a href="#" class="ml-2" @click.prevent="toggleComment(p.tszam)">
										<i class="fa fa-comment mr-1"></i>{{ rows[p.tszam].showComment ? 'Megjegyzés elrejtése' : 'Megjegyzés' }}
									</a>
								</div>
							</div>

							<div class="op2-product-controls">
								<div class="input-group input-group-sm op2-price">
									<input
										type="number"
										min="0"
										class="form-control text-right"
										v-model.number="rows[p.tszam].ar"
										@keyup.enter="add(p)"
									>
									<div class="input-group-append">
										<span class="input-group-text">Ft</span>
									</div>
								</div>

								<div class="input-group input-group-sm op2-qty">
									<div class="input-group-prepend">
										<button class="btn btn-outline-secondary" @click.prevent="step(p.tszam, -1)" :disabled="rows[p.tszam].db <= 1">
											<i class="fa fa-minus"></i>
										</button>
									</div>
									<input
										type="number"
										min="1"
										class="form-control text-center"
										v-model.number="rows[p.tszam].db"
										@keyup.enter="add(p)"
									>
									<div class="input-group-append">
										<button class="btn btn-outline-secondary" @click.prevent="step(p.tszam, 1)">
											<i class="fa fa-plus"></i>
										</button>
									</div>
								</div>

								<button
									class="btn btn-sm btn-primary op2-add"
									@click.prevent="add(p)"
									:disabled="!(rows[p.tszam].db >= 1)"
								>
									<i class="fa fa-cart-plus mr-1"></i>Kosárba
								</button>
							</div>

							<div class="op2-product-comment" v-if="rows[p.tszam].showComment">
								<input
									type="text"
									class="form-control form-control-sm"
									placeholder="Rendelési megjegyzés ehhez a tételhez"
									v-model="rows[p.tszam].rendmegj"
									@keyup.enter="add(p)"
								>
							</div>
						</div>
						</template>
						</div>
					</div>
				</div>
			</div>

			<!-- Kosár összesítő -->
			<div class="col-12 col-lg-3">
				<div class="card op2-card op2-cart" ref="cart">
					<div class="card-header op2-card-header d-flex align-items-center">
						<i class="fa fa-shopping-cart mr-2"></i>
						<span class="font-weight-bold">Kosár</span>
						<span class="badge badge-pill badge-primary ml-2">{{ inCart.length }}</span>
						<a href="#" class="ml-auto small text-danger" v-if="inCart.length > 0" @click.prevent="emptyCart">
							Ürítés
						</a>
					</div>

					<div class="card-body text-center text-muted py-4" v-if="inCart.length === 0">
						<i class="fa fa-shopping-basket fa-2x mb-2 d-block"></i>
						A kosár üres.<br>
						<small>Válassz terméket a listából.</small>
					</div>

					<ul class="list-group list-group-flush op2-cart-list" v-else>
						<li class="list-group-item op2-cart-item" v-for="(item, index) in inCart" :key="`cart-${index}`">
							<div class="d-flex align-items-start">
								<div class="flex-grow-1 font-weight-bold small">{{ item.nev }}</div>
								<button class="btn btn-link btn-sm text-danger p-0 ml-2" @click.prevent="removeFromCart(index)" title="Törlés">
									<i class="fa fa-trash"></i>
								</button>
							</div>
							<div class="d-flex align-items-center flex-wrap mt-1 op2-cart-line">
								<div class="btn-group btn-group-sm">
									<button class="btn btn-outline-secondary" @click.prevent="rFromCart(index)">
										<i class="fa fa-minus"></i>
									</button>
									<span class="btn btn-outline-secondary disabled op2-cart-qty">{{ item.db }}</span>
									<button class="btn btn-outline-secondary" @click.prevent="pToCart(index)">
										<i class="fa fa-plus"></i>
									</button>
								</div>
								<span class="small text-muted mx-1">×</span>
								<div class="input-group input-group-sm op2-cart-price">
									<input
										type="number"
										min="0"
										step="1"
										class="form-control text-right"
										:value="item.ar"
										@change="setPrice(index, $event)"
										@keyup.enter="$event.target.blur()"
										title="Egységár módosítása"
									>
									<div class="input-group-append">
										<span class="input-group-text">Ft</span>
									</div>
								</div>
								<span class="ml-auto font-weight-bold small text-nowrap">{{ item.ar * item.db | huf }} Ft</span>
							</div>
							<div class="small text-muted mt-1" v-if="item.rendmegj">
								<i class="fa fa-comment mr-1"></i>{{ item.rendmegj }}
							</div>
						</li>
					</ul>

					<div class="card-footer bg-white" v-if="inCart.length > 0">
						<div class="d-flex justify-content-between small text-muted">
							<span>Tételek</span><span>{{ inCart.length }}</span>
						</div>
						<div class="d-flex justify-content-between small text-muted">
							<span>Darab</span><span>{{ numInCart }} db</span>
						</div>
						<div class="d-flex justify-content-between align-items-baseline mt-2">
							<span class="font-weight-bold">Összesen</span>
							<span class="op2-total">{{ cartSum | huf }} Ft</span>
						</div>
						<router-link class="btn btn-success btn-block mt-3" :to="'/orders/ordersum'">
							Tovább a véglegesítéshez <i class="fa fa-chevron-right ml-1"></i>
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<!-- Mobil: alsó összesítő sáv -->
		<div class="op2-mobilebar d-lg-none" v-if="inCart.length > 0">
			<a href="#" class="text-dark" @click.prevent="scrollToCart">
				<i class="fa fa-shopping-cart mr-1"></i>{{ numInCart }} db · <b>{{ cartSum | huf }} Ft</b>
			</a>
			<router-link class="btn btn-success btn-sm" :to="'/orders/ordersum'">
				Véglegesítés <i class="fa fa-chevron-right ml-1"></i>
			</router-link>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'

export default {
	name: 'order_products_v2',

	data() {
		return {
			rend_datum: this.$moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
			ballon: null,
			lastorder: [],
			products: [],
			rows: {},
			loading: true,
			search: '',
			activeTab: 'osszes',
			collapsed: {},
			// A menüsáv (sticky-top) alatti távolság a ragadós kosárnak
			stickyTop: 72
		}
	},

	created() {
		this.req.get('/orders/ugyfel/ballon/' + this.rend_sel_customer.uszam)
			.then(res => { this.ballon = res.data.ballon })
			.catch(() => { this.ballon = 'error' })

		this.req.post(`orders/lastorder/${this.rend_sel_customer.id}`)
			.then(res => { this.lastorder = res.data.rend || [] })
			.catch(err => console.log(err))

		this.$Progress.start()
		this.req.post('products/search', { search: { aktiv: 1 } })
			.then(res => {
				let rows = {}
				for (let p of res.data.products) {
					rows[p.tszam] = { db: 1, ar: ~~p.ar, rendmegj: '', showComment: false }
				}
				this.rows = rows
				this.products = res.data.products
				this.loading = false
				this.$Progress.finish()
			})
			.catch(err => {
				console.log(err)
				this.loading = false
				this.$Progress.fail()
			})
	},

	mounted() {
		this.measureNavbar()
		window.addEventListener('resize', this.measureNavbar)

		if (!this.$route.query.plus) {
			this.setrendszam(`${this.$moment().unix()}${this.user.azon}`)
			this.refreshdate()
		} else {
			this.rend_datum = this.renddatum
		}
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.measureNavbar)
	},

	methods: {
		...mapActions(['setrendszam', 'setrenddatum', 'addToCart', 'removeCart', 'removeFromCart', 'rFromCart', 'pToCart', 'setCartPrice']),

		// Egységár módosítása a kosárban: nem negatív egész Ft; hibás értéknél marad a régi
		setPrice(index, event) {
			let v = String(event.target.value).trim()
			let ar = Number(v)
			if (v === '' || !Number.isInteger(ar) || ar < 0) {
				event.target.value = this.inCart[index].ar
				toastr.error('Az ár csak nem negatív egész szám lehet')
				return
			}
			this.setCartPrice({ index, ar })
		},

		measureNavbar() {
			let nav = document.querySelector('.sticky-top')
			this.stickyTop = (nav ? nav.offsetHeight : 56) + 16
		},

		refreshdate() {
			this.setrenddatum(this.rend_datum)
		},

		tabCount(tab) {
			return this.products.filter(p => this.inTab(p, tab)).length
		},

		inTab(p, tab) {
			if (tab === 'osszes') return true
			if (tab === 'kiemelt') return p.listType > 0
			return p.listType == tab
		},

		step(tszam, num) {
			let row = this.rows[tszam]
			row.db = Math.max(1, ~~row.db + num)
		},

		toggleComment(tszam) {
			this.rows[tszam].showComment = !this.rows[tszam].showComment
		},

		isLimited(p) {
			let szolg = this.rend_sel_customer.szolgaltato
			return Array.isArray(p.limitSzolg) && p.limitSzolg.length > 0 && szolg
				&& !p.limitSzolg.some(x => Number(x) === Number(szolg))
		},

		toggleGroup(key) {
			this.$set(this.collapsed, key, !this.collapsed[key])
		},

		groupInCart(group) {
			return group.items.reduce((s, p) => s + this.cartQty(p.tszam), 0)
		},

		cartQty(tszam) {
			return this.inCart.filter(x => x.tszam === tszam).reduce((s, x) => s + ~~x.db, 0)
		},

		// Ugyanaz a tétel formátum, mint a régi order_item-ben, hogy az order_sum változatlanul működjön
		toCartItem(p, db, ar, rendmegj) {
			return {
				tszam: p.tszam,
				nev: p.nev,
				ar: ~~ar,
				db: ~~db,
				rendmegj: rendmegj || '',
				szalmegj: '',
				limitSzolg: p.limitSzolg
			}
		},

		add(p) {
			let row = this.rows[p.tszam]
			if (!(row.db >= 1)) return

			this.addToCart(this.toCartItem(p, row.db, row.ar, row.rendmegj))
			toastr.success(`${p.nev} – ${row.db} db a kosárban`)

			row.db = 1
			row.rendmegj = ''
			row.showComment = false
		},

		findProduct(tszam) {
			return this.products.find(p => p.tszam == tszam) || { tszam, nev: tszam, limitSzolg: [] }
		},

		addLastItem(item) {
			let p = this.findProduct(item.tszam)
			this.addToCart(this.toCartItem({ ...p, nev: item.nev }, item.db, item.ar, item.rendmegj))
			toastr.success(`${item.nev} a kosárban`)
		},

		addLastOrder() {
			for (let item of this.lastorder) {
				let p = this.findProduct(item.tszam)
				this.addToCart(this.toCartItem({ ...p, nev: item.nev }, item.db, item.ar, item.rendmegj))
			}
			toastr.success(`Az utolsó rendelés ${this.lastorder.length} tétele a kosárban`)
		},

		emptyCart() {
			this.removeCart()
		},

		scrollToCart() {
			this.$refs.cart.scrollIntoView({ behavior: 'smooth' })
		}
	},

	computed: {
		...mapGetters(['rend_sel_customer', 'user', 'rendszam', 'renddatum', 'inCart', 'cartSum']),

		tabs() {
			let tabs = [{ value: 'kiemelt', text: 'Kiemelt' }]
			for (let t of this.productListTypes) {
				if (t.value > 0) tabs.push({ value: t.value, text: t.text })
			}
			tabs.push({ value: 'osszes', text: 'Összes' })
			return tabs
		},

		filteredProducts() {
			let s = this.search.trim().toLowerCase()
			// Keresésnél minden terméket nézünk, ne kelljen fület váltani
			if (s) return this.products.filter(p => p.nev.toLowerCase().includes(s) || String(p.tszam) === s)
			return this.products.filter(p => this.inTab(p, this.activeTab))
		},

		// Az "Összes" fülön a termékek csoportonként (Aqua, Fitrade 1000, Fitrade 500, egyéb) jelennek meg
		isGrouped() {
			return this.activeTab === 'osszes' && !this.search.trim()
		},

		productGroups() {
			let list = this.filteredProducts
			if (!this.isGrouped) return [{ key: 'all', title: null, items: list }]

			// Csoportonkénti szín és ikon (lista típus szerint)
			let style = {
				1: { color: '#0a6ebd', icon: 'fa-tint' },
				2: { color: '#e8590c', icon: 'fa-wine-bottle' },
				3: { color: '#7048e8', icon: 'fa-wine-bottle' }
			}
			let groups = this.productListTypes
				.filter(t => t.value > 0)
				.map(t => ({
					key: t.value,
					title: t.text,
					items: list.filter(p => p.listType == t.value),
					...(style[t.value] || { color: '#6c757d', icon: 'fa-box' })
				}))
			groups.push({ key: 'egyeb', title: 'Egyéb termékek', items: list.filter(p => !(p.listType > 0)), color: '#6c757d', icon: 'fa-box' })

			return groups.filter(g => g.items.length > 0)
		},

		numInCart() {
			return this.inCart.reduce((total, x) => total + ~~x.db, 0)
		},

		tel() {
			let v = Vue.filter('tel')(this.rend_sel_customer.telv)
			let m = Vue.filter('tel')(this.rend_sel_customer.telm)
			return `${v}${v && m ? ' - ' : ''}${m}`
		}
	}
}
</script>

<style scoped>
.op2 {
	padding-bottom: 72px;
}

.op2-card {
	border: 1px solid #e3e8ee;
	border-radius: 10px;
	box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
	overflow: hidden;
}

/* A .card position:relative, a dátumválasztó lenyílója ehhez igazodik: a fejléc nem vághatja le
 * (overflow), és a ragadós kosár fölött kell lennie, de a menüsáv (sticky-top, 1020) alatt */
.op2-header {
	overflow: visible;
	position: relative;
	z-index: 3;
}

.op2-card-header {
	background: #f8fafc;
	border-bottom: 1px solid #e3e8ee;
}

.op2-customer-name {
	font-size: 1.25rem;
	font-weight: 700;
	line-height: 1.2;
}

.op2-badge {
	font-weight: 500;
	padding: 0.35em 0.6em;
	margin: 0 0.25rem 0.25rem 0;
	border: 1px solid #e3e8ee;
}

.op2-tabs {
	display: flex;
	flex-wrap: wrap;
	gap: 0.35rem;
}

@media (min-width: 768px) {
	.op2-tabs {
		justify-content: flex-end;
	}
}

.op2-groups {
	padding: 1rem;
	background: #f8fafc;
}

.op2-group {
	background: #fff;
	border: 1px solid #e3e8ee;
	border-top: 4px solid var(--op2-accent);
	border-radius: 8px;
	overflow: hidden;
	margin-bottom: 1rem;
}

.op2-group:last-child {
	margin-bottom: 0;
}

.op2-group-header {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.6rem;
	padding: 0.7rem 1rem;
	border-bottom: 1px solid #eef1f4;
	cursor: pointer;
	user-select: none;
}

.op2-group-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	color: #fff;
	background: var(--op2-accent);
}

.op2-group-name {
	font-size: 1.1rem;
	font-weight: 700;
	color: var(--op2-accent);
}

.op2-group-count {
	font-size: 0.8rem;
	color: #6b7785;
}

.op2-group-incart {
	font-size: 0.8rem;
	font-weight: 600;
	color: #1e7e34;
	background: #e6f4ea;
	border-radius: 999px;
	padding: 0.15rem 0.6rem;
}

.op2-group-chevron {
	color: #9aa5b1;
}

.op2-product {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0.75rem 1rem;
	border-bottom: 1px solid #eef1f4;
	transition: background-color 0.15s;
}

.op2-product:last-child {
	border-bottom: 0;
}

.op2-product:hover {
	background: #f8fafc;
}

.op2-product-incart {
	box-shadow: inset 3px 0 0 #28a745;
}

.op2-product-main {
	flex: 1 1 260px;
	min-width: 0;
	padding-right: 1rem;
}

.op2-product-name {
	font-weight: 600;
}

.op2-product-controls {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.op2-price {
	width: 120px;
}

.op2-qty {
	width: 130px;
}

.op2-add {
	white-space: nowrap;
}

.op2-product-comment {
	flex: 1 1 100%;
	margin-top: 0.5rem;
}

.op2-last-item {
	padding: 0.5rem 1rem;
}

.op2-cart {
	scroll-margin-top: var(--op2-top, 72px);
}

.op2-cart-list {
	max-height: 55vh;
	overflow-y: auto;
}

.op2-cart-item {
	padding: 0.6rem 0.9rem;
}

.op2-cart-line {
	gap: 0.25rem 0;
}

.op2-cart-price {
	width: 105px;
}

.op2-cart-price input {
	padding-left: 0.3rem;
	padding-right: 0.3rem;
}

.op2-cart-qty {
	min-width: 2.5rem;
	opacity: 1 !important;
	color: #212529;
}

.op2-total {
	font-size: 1.35rem;
	font-weight: 700;
	color: #1e7e34;
}

@media (min-width: 992px) {
	.op2-cart {
		position: sticky;
		top: var(--op2-top, 72px);
	}

	/* A lista görgethető, a fejléc és az összesítő mindig látszik */
	.op2-cart-list {
		max-height: calc(100vh - var(--op2-top, 72px) - 260px);
		min-height: 120px;
	}

	.op2 {
		padding-bottom: 0;
	}
}

@media (max-width: 575px) {
	.op2-product-controls {
		width: 100%;
		margin-top: 0.5rem;
	}

	.op2-price,
	.op2-qty {
		flex: 1 1 0;
		width: auto;
	}
}

.op2-mobilebar {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1030;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.6rem 1rem;
	background: #fff;
	border-top: 1px solid #e3e8ee;
	box-shadow: 0 -2px 8px rgba(16, 24, 40, 0.08);
}
</style>



// WEBPACK FOOTER //
// src/components/orders/new_order/order_products2.vue